var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V6L10 0ZM11.923 15.698C11.682 16.266 11.201 16.509 10.64 16.347C10.159 16.185 9.597 15.779 9.036 15.131C8.475 15.212 7.913 15.374 7.352 15.536C6.71 16.671 6.069 17.644 5.427 17.887C5.266 17.968 5.106 18 4.945 18C4.624 18 4.384 17.887 4.223 17.644C4.063 17.401 3.742 16.914 4.383 16.185C4.784 15.698 5.746 15.212 6.789 14.888C7.11 14.239 7.35 13.591 7.591 12.861C7.03 11.807 6.709 10.672 6.789 10.023C6.87 9.373 7.282 9 7.832 9C8.382 9 8.714 9.373 8.875 9.941C9.035 10.59 8.875 11.644 8.474 12.86C8.715 13.347 9.035 13.833 9.356 14.319C10.318 14.238 11.12 14.238 11.602 14.562C12.003 14.806 12.083 15.211 11.923 15.698ZM9 7V1.5L14.5 7H9Z",
    fill: "#F71F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePdf);
export default __webpack_public_path__ + "static/media/image_pdf.29ad39e3973b7b93254b6222f00461f1.svg";
export { ForwardRef as ReactComponent };